import { render, staticRenderFns } from "./assetsList.vue?vue&type=template&id=aa1328fe"
import script from "./assetsList.vue?vue&type=script&lang=js"
export * from "./assetsList.vue?vue&type=script&lang=js"
import style0 from "./assetsList.vue?vue&type=style&index=0&id=aa1328fe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports